import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faServer, faTruck } from "@fortawesome/free-solid-svg-icons";
import { faFortAwesome } from "@fortawesome/free-brands-svg-icons";
import { SmoothScrollButton } from "../../FormCommon/SmoothScroll";

class CallToAction extends React.Component {
    render() {
        return (
            <React.Fragment>
                <section className="bg-white" id="cta">
                    <div className="container py-6 text-center">
                        <h3 className="cta-title">We provide freight and logistics between Sydney and Perth</h3>
                        <SmoothScrollButton
                            to="contact-us"
                            className="btn btn-primary btn-marketing rounded-pill mr-3 my-2 lift lift-sm"
                            content="Get a Quote"
                        />
                    </div>
                </section>

            </React.Fragment>
        );
    }
}

export default CallToAction;
